import "react-toastify/dist/ReactToastify.css";
import { toast } from "react-toastify";

const options = {
  position: "top-right",
  autoClose: 1000,
  hideProgressBar: true,
  closeOnClick: true,
  pauseOnHover: true,
  draggable: true,
};

export const ToastNotifyInfo = (message, id) => {
  toast.info(message, {
    ...options, style: {
      fontFamily: "Lexend", fontSize: "14px"
    }, toastId: `info-${id}`
  });
};

export const ToastNotifySuccess = (message, id) => {
  toast.success(message, {
    ...options, style: {
      fontFamily: "Lexend", fontSize: "14px"
    }, toastId: `success-${id}`
  });
};

export const ToastNotifyError = (message, id) => {
  toast.error(message, {
    ...options, style: {
      fontFamily: "Lexend", fontSize: "14px"
    }, toastId: `error-${id}`
  });
};
